export default __webpack_public_path__ + "static/media/Brigand's Boots of the Grasslands.05238ad1.jpg";